import { useMutation, useQuery } from '@tanstack/react-query';
import { store } from '../..';
import { queryClient } from '../../..';
import { setAlert, setIsLoading } from '../../components/components-slice';
import { nhisApis } from './../../../api/payroll/statutory-compliance/nhis';
import moment from 'moment';
import { formatNumber } from '../../../utils/functions';

export function useGetNhisHistory(limit, page, statusFilter, search) {
  return useQuery(
    ['nhis', { limit, page, statusFilter, search }],
    () => {
      store.dispatch(setIsLoading(true));
      return nhisApis.getNHIS({
        limit,
        page,
        statusFilter,
        search,
      });
    },
    {
      select(data) {
        data?.data?.forEach((nhis) => {
          nhis.created = moment(nhis.created).format('MMMM DD, YYYY');
          nhis.month = moment(nhis.month).format('MMMM, YYYY');
          nhis.status = parseFloat(nhis.nhis_status)
          if (nhis.status === 2) {
            nhis.status = 0
          }
          switch (nhis.status) {
            case 0:
              nhis.computedActions = [0];
              break;
            case 1:
              nhis.computedActions = [1];
              break;
            default:
              break;
          }
        });

        return data;
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false));
      },
      // keepPreviousData: true
    },
  );
}

export function useUploadNhis() {
  return useMutation(
    (payload) => {
      return nhisApis.bulkNHIS(payload);
    },
    {
      onSuccess: () => {
        queryClient.invalidateQueries('nhis');
        store.dispatch(setAlert(true, 'success', 'Upload Successful'));
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false));
      },
    },
  );
}

export function useRefNHIS(refId, limit, page, search) {
  return useQuery(
    ['nhis-by-ref', { refId, limit, page, search }],
    () => {
      store.dispatch(setIsLoading(true));
      return nhisApis.fetchNHISByRef({refId, limit, page, search});
    },
    {
      select: (data) => {
        
        data?.data?.forEach((item) => {
            item.computedActions = [0]
          item.employeeName = `${item.first_name} ${item.last_name}`;
          if (!item.status) {
            item.status = 0
          }
          item.table_nhis_amount = formatNumber(parseFloat(item.amount.toFixed(2)), 2);
        });
        if (data) {
          data.formatted_total_amount = formatNumber(parseFloat(data?.total_amount.toFixed(2)), 2);
          data.formatted_total_trans_cost = formatNumber(parseFloat(data?.total_trans_cost.toFixed(2)), 2);
          data.formatted_total_payable = formatNumber(parseFloat(data?.total_payable.toFixed(2)), 2);
        }
        return data;
      },
      onSettled: (data, error, variables, context) => {
        store.dispatch(setIsLoading(false));
      },
    },
  );
}